import { isElementNode, isTag } from 'anodum';
import { COLORED_ELEMENT } from '../constants/editable-elements';

const isColoredElement = (element) => {
  if (!isElementNode(element)) return false;

  return isTag(element, COLORED_ELEMENT);
};

export default isColoredElement;
